import { useEffect, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import Overlay from './containers/Overlay'
import { locale as initialLocale } from '@/root.component'
import {
	ability,
	AbilityContext,
	permissionsActions,
} from '@Techedge/digitalportal-shared'
import {
	importMessages,
	LocaleMessages,
	SmartlyIntlProvider,
} from './../app/utils/localization/intlHelper'
import './App.scss'
import { withTransaction } from '@elastic/apm-rum-react'
import apm from '@Techedge/smart-root'

export const App = (props: any) => {
	const [locale, setLocale] = useState<string>(initialLocale)
	const [messages, setMessages] = useState<LocaleMessages | null>(null)

	useEffect(() => {
		setLocale(initialLocale)
		moment.locale(initialLocale)
	}, [])

	useEffect(() => {
		if (props?.language && props?.dictionary) {
			setLocale(props.language)
			moment.locale(props.language)
			importMessages(props.language).then(() => {
				setMessages(props.dictionary)
			})
		}
	}, [props?.language, props?.dictionary])

	return (
		<SmartlyIntlProvider locale={locale} messages={messages}>
			<AbilityContext.Provider value={ability}>
				{!!messages && <Overlay {...props} />}
			</AbilityContext.Provider>
		</SmartlyIntlProvider>
	)
}

const mapStateToProps = (state: any) => ({
	token: state.userReducer.accessToken,
	language: state.userReducer.user.language,
	dictionary: state.userReducer.user.dictionary,
})

const mapDispatchToProps = (dispatch: any) => ({
	getActions: () => dispatch(permissionsActions.getActions()),
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
